// A small round reload control for a My Desk panel (owner, 2026-09-25:
// "should just be a little logo like a send/receive circle to reload").
// One circle with the two curved arrows, no text; the label is for screen
// readers and the tooltip. It sits in its own right-aligned row so it never
// stretches to fill a panel the way a bare button in a flex column does.
import type { ComponentChildren, JSX } from 'preact';

export function ReloadButton(
  { label, onClick, testId, leading = null }: {
    label: string; onClick: () => void; testId?: string;
    /** Something short to sit on the same line, left of the circle — a
     * panel's "2 unread" — so the line is not spent on the icon alone. */
    leading?: ComponentChildren;
  },
): JSX.Element {
  return (
    <div class="panel-tools">
      {leading}
      <button type="button" class="mini reload" aria-label={label} title={label} data-testid={testId} onClick={onClick}>
        <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">
          <path d="M20 12a8 8 0 0 1-13.7 5.6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
          <path d="M4 12a8 8 0 0 1 13.7-5.6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
          <path d="M17.7 2.5v3.9h-3.9" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M6.3 21.5v-3.9h3.9" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  );
}
